export default function About() {
  return (
    <div className="text-center text-4xl bg-black py-2 mb-8 text-white">About</div>
  )
}